import { useEffect } from 'react'

function useTriggerInContentLereYmalExperiment(shouldTrigger: boolean) {
  useEffect(() => {
    if (shouldTrigger) {
      dataLayer.push({ event: 'optimize.inContentYmal' })
    }
  }, [shouldTrigger])
}

export default useTriggerInContentLereYmalExperiment
